// extracted by mini-css-extract-plugin
module.exports = {"blockButton":"styles_blockButton__1IBKZ","tooltip":"styles_tooltip__3Y2G8"};